import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

export const getDates = (startDate, endDate) => {
    const dateArray = [];
    let currentDate = startDate;
    while (currentDate <= endDate) {
        dateArray.push(currentDate);
        currentDate = new Date(dayjs(currentDate).add(1, 'days').toDate());
    }
    return dateArray;
};

export const getDate = (date: string) => dayjs(date).tz('Asia/Jerusalem');
